<template>
    <div class="resident">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" v-if="model.created_at">
                <header>
                    <h4>{{model.fullName}}</h4>
                    <h5><a :href="'/projects/' + model.project_id">{{model.project.name}}</a></h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <label-type-toggle
                    class="form-group"
                    labelable-type="App\Lease"
                    :labelable-id="model.lease_id"
                ></label-type-toggle>

                <label-type-toggle
                    class="form-group"
                    labelable-type="App\Resident"
                    :labelable-id="model.id"
                ></label-type-toggle>

                <form method="POST" accept-charset="UTF-8" novalidate="novalidate" @submit.prevent="saveModel">
                    <div class="row">
                        <div class="col-sm-6 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[first_name]')}">
                            <label for="resident-first-name">First Name</label>
                            <input id="resident-first-name"
                                   required="required"
                                   name="Resident[first_name]"
                                   type="text"
                                   v-validate="'required'"
                                   v-model="model.first_name"
                                   class="form-control">

                            <span v-show="errors.has('resident.Resident[first_name]')" class="help-block">
                                {{ errors.first('resident.Resident[first_name]') }}
                            </span>
                        </div>
                        <div class="col-sm-6 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[last_name]')}">
                            <label for="resident-last-name">Last Name</label>
                            <input id="resident-last-name"
                                   required="required"
                                   name="Resident[last_name]"
                                   type="text"
                                   v-validate="'required'"
                                   v-model="model.last_name"
                                   class="form-control">
                            <span v-show="errors.has('resident.Resident[last_name]')" class="help-block">
                                {{ errors.first('resident.Resident[last_name]') }}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[email]')}">
                            <label for="resident-email">Email</label>
                            <input id="resident-email"
                                   name="Resident[email]"
                                   type="email"
                                   class="form-control"
                                   v-model="model.email">

                            <span v-show="errors.has('resident.Resident[email]')" class="help-block">
                                {{ errors.first('resident.Resident[email]') }}
                            </span>
                        </div>

                        <div class="col-sm-6 col-md-3 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[phone]')}">
                            <label for="resident-phone">Phone</label>
                            <input id="resident-phone"
                                   name="Resident[phone]"
                                   type="tel"
                                   class="form-control"
                                   v-model="model.phone">
                            <span v-show="errors.has('resident.Resident[phone]')" class="help-block">
                                {{ errors.first('resident.Resident[phone]') }}
                            </span>
                        </div>

                        <div class="col-sm-6 col-md-3 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[phone_2]')}">
                            <label for="resident-phone-2">Phone 2</label>
                            <input id="resident-phone-2"
                                   name="Resident[phone_2]"
                                   type="tel"
                                   class="form-control"
                                   v-model="model.phone_2">
                            <span v-show="errors.has('resident.Resident[phone_2]')" class="help-block">
                                {{ errors.first('resident.Resident[phone_2]') }}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-4 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[charge]')}">
                            <label for="resident-charge">Charge</label>

                            <div class="input-group">
                                <span class="input-group-addon">$</span>
                                <input id="resident-charge"
                                       min="0"
                                       name="Resident[charge]"
                                       type="number"
                                       class="form-control"
                                       v-model="model.charge">
                            </div>

                            <span v-show="errors.has('resident.Resident[charge]')" class="help-block">
                                {{ errors.first('resident.Resident[charge]') }}
                            </span>
                        </div>

                        <div class="col-sm-6 col-md-4 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[provider_company_id]')}">
                            <label for="resident-provider-company-id">Former Provider</label>
                            <select id="resident-provider-company-id"
                                    name="Resident[provider_company_id]"
                                    class="form-control"
                                    v-model="model.provider_company_id">
                                <option value="">None</option>
                                <option v-for="company in companies" :value="company.id">
                                    {{company.name}}
                                </option>
                            </select>

                            <span v-show="errors.has('resident.Resident[provider_company_id]')" class="help-block">
                                {{ errors.first('resident.Resident[provider_company_id]') }}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[external_id]')}">
                            <label for="resident-external-id">External ID</label>
                            <input id="resident-external-id"
                                   name="Resident[external_id]"
                                   type="text"
                                   class="form-control"
                                   v-model="model.external_id">

                            <span v-show="errors.has('resident.Resident[external_id]')" class="help-block">
                                {{ errors.first('resident.Resident[external_id]') }}
                            </span>
                        </div>

                        <div class="col-sm-6 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[provider_account_external_id]')}">
                            <label for="resident-provider-account-external-id">Provider Account ID</label>

                            <input id="resident-provider-account-external-id"
                                   name="Resident[provider_account_external_id]"
                                   type="text"
                                   class="form-control"
                                   v-model="model.provider_account_external_id">

                            <span v-show="errors.has('resident.Resident[provider_account_external_id]')" class="help-block">
                                {{ errors.first('resident.Resident[provider_account_external_id]') }}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-9 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[address]')}">
                            <label for="resident-address">Address</label>
                            <input id="resident-address"
                                   name="Resident[address]"
                                   type="text"
                                   class="form-control"
                                   v-model="model.address">
                            <span v-show="errors.has('resident.Resident[address]')" class="help-block">
                                {{ errors.first('resident.Resident[address]') }}
                            </span>
                        </div>
                        <div class="col-xs-3 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[address_2]')}">
                            <label for="resident-address-2">Apartment</label>
                            <input id="resident-address-2"
                                   name="Resident[address_2]"
                                   type="text"
                                   class="form-control"
                                   v-model="model.address_2">
                            <span v-show="errors.has('resident.Resident[address_2]')" class="help-block">
                                {{ errors.first('resident.Resident[address_2]') }}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-4 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[city]')}">
                            <label for="resident-city">City</label>
                            <input id="resident-city"
                                   name="Resident[city]"
                                   type="text"
                                   class="form-control"
                                   v-model="model.city">
                            <span v-show="errors.has('resident.Resident[city]')" class="help-block">
                                {{ errors.first('resident.Resident[city]') }}
                            </span>
                        </div>
                        <div class="col-sm-4 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[state]')}">
                            <label for="resident-state">State</label>
                            <select id="resident-state"
                                    name="Resident[state]"
                                    class="form-control"
                                    v-model="model.state">
                                <option selected="selected" value="">State</option>
                                <option v-for="(label, value) in states" :value="value">{{label}}</option>
                            </select>
                            <span v-show="errors.has('resident.Resident[state]')" class="help-block">
                                {{ errors.first('resident.Resident[state]') }}
                            </span>
                        </div>

                        <div class="col-sm-4 form-group has-feedback"
                             :class="{'has-error': errors.has('resident.Resident[postal_code]')}">
                            <label for="resident-postal-code">Postal Code</label>
                            <input id="resident-postal-code"
                                   maxlength="5"
                                   name="Resident[postal_code]"
                                   type="text"
                                   class="form-control"
                                   v-model="model.postal_code">
                            <span v-show="errors.has('resident.Resident[postal_code]')" class="help-block">
                                {{ errors.first('resident.Resident[postal_code]') }}
                            </span>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-xs-6 col-md-8 form-group">
                        </div>
                        <div class="col-xs-6 col-md-4 form-group">
                            <button type="submit" class="_submit-button btn btn-success btn-lg btn-block">
                                <i aria-hidden="true" class="fa fa-floppy-o"></i>&nbsp;Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    const { states } = require( '../constants.json' );
    import model from "./mixins/model";

    export default {
        mixins: [ model ],

        computed: {
            url(){
                if( this.model.id ){
                    return '/api/residents/' + this.model.id;
                }
                else {
                    return '/api/residents';
                }
            },

            saveValidationKey(){
                return 'resident'
            },

            resourceKey(){
                return 'Resident';
            },
        },

        methods: {
            beforeLoad(){
                return this.loadCompanies();
            },

            getModelData(){
                return {
                    companies: [],

                    states: states,
                };
            },

            loadCompanies(){
                return axios.get( '/api/companies?category=2' )
                    .then( ( response ) => {
                        var companies = response.data.Companies;

                        this.$set( this, 'companies', companies );
                    } );
            },
        }
    }
</script>
